import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getContracts, createContract, deleteContract } from '../api/employeesContract.api';
import { IContract, IGetContracts } from '../models/employeesContract.model';

interface IContractState {
  contracts: IContract[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IContractState = {
  contracts: [],
  isLoading: false
};

const contractSlicer = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    getContractsStart: (state: IContractState) => {
      state.contracts = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getContractsSuccess: (state: IContractState, action: PayloadAction<IGetContracts>) => {
      state.contracts = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getContractsFailure: (state: IContractState, action: PayloadAction<AxiosError|string>) => {
      state.contracts = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IContractState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IContractState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IContractState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    deleteSuccess: (state: IContractState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  }
});

export const {
  getContractsStart,
  getContractsSuccess,
  getContractsFailure,
  requestStart,
  requestFailure,
  createSuccess,
  deleteSuccess
} = contractSlicer.actions;

export default contractSlicer.reducer;

export const doGetContracts = (memberId: string): any => async (dispatch: any) => {
  try {
    dispatch(getContractsStart());
    const response = await getContracts(memberId);
    dispatch(getContractsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getContractsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateContract = (memberId: string, data: any): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createContract(memberId, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doDeleteContract = (contractId: string): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await deleteContract(contractId);
    dispatch(deleteSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
